import { cn } from '../utils';
import FacebookSvg from './facebook.svg?react';
import InstagramSvg from './instagram.svg?react';
import XSvg from './x.svg?react';
import YoutubeSvg from './youtube.svg?react';

const icons = {
  youtube: YoutubeSvg,
  instagram: InstagramSvg,
  facebook: FacebookSvg,
  x: XSvg,
} as const;

export type SocialIconName = keyof typeof icons;

export interface SocialIconProps {
  name: SocialIconName;
  className?: string;
}

export function SocialIcon({ name, className }: SocialIconProps) {
  const Icon = icons[name];
  return <Icon className={cn('size-6', className)} aria-hidden="true" />;
}
